import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// Route-level code splitting (src/lazyRoute.tsx): the module's route table and screens load on first visit
const KnowledgeRoutes = lazyRoute(() => import('./KnowledgeRoutes').then((m) => m.KnowledgeRoutes));

/** The knowledge base and AI guards, under /agencies/:agencyId/knowledge */
export const knowledgeAgencyRoutes = <Route path="knowledge/*" element={<KnowledgeRoutes />} />;
